import React from "react";
import PropTypes from "prop-types";
import { UrlProvider } from "../../../utils/UrlProvider";

const Button = ({ data }) => {
  if (!data) {
    return;
  }
  const { feature_title, feature_description, icon } =
    data !== undefined && data;
  return (
    data && (
      <div className="flex justify-center items-center md:pt-[4.5vw] pt-[15vw] md:w-[100%] w-[90%] m-auto">
        <button
          className={` bg-[#2E3192] text-white flex md:gap-x-[1vw] gap-x-[3vw] md:px-[1vw] px-[6vw] md:py-[1vw] py-[4vw] md:rounded-full rounded-[4vw]`}
        >
          <div className="flex justify-center items-center">
            <img
              src={UrlProvider(icon?.url)}
              alt={icon?.alternativeText}
              className="md:w-[100%] w-[4vw] mt-[1vw] md:mt-0"
            />
          </div>
          <div className="md:flex flex-row md:w-auto w-[75%] justify-center md:text-center text-left items-center md:leading-tight leading-[3.5vw]">
            <span className="md:text-[0.8vw] text-[3vw] font-[700] font-krubRegular">
              {feature_title}
            </span>
            <span className="md:text-[0.8vw] text-[3vw] md:pl-[0.3vw] pl-[1vw] font-[400] font-krubRegular">
              {feature_description}
            </span>
          </div>
        </button>
      </div>
    )
  );
};

Button.propTypes = {
  data: PropTypes.object,
};
export default Button;
